import { Box, ButtonGroup } from '@chakra-ui/react';
import LinkButton from '../../components/custom/LinkButton';
import AddProjectForm from '../../components/forms/project/AddProjectForm';
import PageHeader from '../../components/common/PageHeader';

export default function AddProject() {
    return (
        <>
            <div className='admin-page-header'>
                <PageHeader headerTitle={"プロジェクト登録"} />
                <ButtonGroup gap={2}>
                    <LinkButton buttonText={'戻る'} buttonUrl={'/technologies'}/>
                </ButtonGroup>
            </div>
            <Box className='admin-box'>
                <AddProjectForm />
            </Box>
        </>   
    ) 
}
